import {unsubscribeUser} from '../helpers';

const unsubscribeFromPushSubscription = () => {
  return unsubscribeUser();
};

export default unsubscribeFromPushSubscription;
